'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reduxForm = require('redux-form');
var _reactScroll = require('react-scroll');
var _reactSelect = require('react-select');var _reactSelect2 = _interopRequireDefault(_reactSelect);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _ProjectImages = require('./ProjectImages');var _ProjectImages2 = _interopRequireDefault(_ProjectImages);

var _PublishPropertyFormConstants = require('../../containers/PublishForm/PublishPropertyFormConstants');

var _components = require('../../components');





var _helpers = require('./helpers');
var _constants = require('./constants');






var _PublishNewHomesForm = require('./PublishNewHomesForm.scss');var styles = _interopRequireWildcard(_PublishNewHomesForm);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}

var PROJECT_YEARS_OPTIONS = (0, _helpers.getYearsOptions)();var

PropertyDetails = function (_Component) {_inherits(PropertyDetails, _Component);function PropertyDetails() {var _temp, _this, _ret;_classCallCheck(this, PropertyDetails);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    formatTypeOptions = function () {return _constants.OPTIONS_STATUS.map(function (type) {return {
          label: _react2.default.createElement('span', null, _this.props.translate('addNewProject', type)),
          value: type };});}, _this.


    renderCompletionDateMonths = function (_ref) {var input = _ref.input,meta = _ref.meta;return _this.renderSelect(Object.assign({}, input), meta, 'month', _constants.PROJECT_MONTHS_OPTIONS);}, _this.
    renderCompletionDateYears = function (_ref2) {var input = _ref2.input,meta = _ref2.meta;return _this.renderSelect(Object.assign({}, input), meta, 'year', PROJECT_YEARS_OPTIONS);}, _this.

    renderStatus = function () {return (
        _react2.default.createElement(_reactScroll.Element, { name: _constants.PROJECT_FIELDS_NAMES.status, className: styles.statusWrapper },
          _react2.default.createElement('span', { className: styles.label },
            _this.props.translate('addNewProject', 'status'),
            _react2.default.createElement('span', { className: 'req' }, '*')),

          _react2.default.createElement('div', { className: styles.selectWrapper },
            _react2.default.createElement(_reduxForm.Field, {
              name: _constants.PROJECT_FIELDS_NAMES.status,
              locale: _this.props.locale,
              component: _this.renderStatusField }))));}, _this.





    renderCompletionDate = function () {return (
        _react2.default.createElement(_reactScroll.Element, { name: _constants.PROJECT_FIELDS_NAMES.completion_date_years, className: styles.completionDateWrapper },
          _react2.default.createElement('span', { className: styles.label },
            _this.props.translate('addNewProject', 'completionDate'),
            _react2.default.createElement('span', { className: 'req' }, '*')),

          _react2.default.createElement('div', { className: styles.completionDate },
            _react2.default.createElement(_reduxForm.Field, {
              name: _constants.PROJECT_FIELDS_NAMES.completion_date_months,
              locale: _this.props.locale,
              component: _this.renderCompletionDateMonths }),

            _react2.default.createElement(_reduxForm.Field, {
              name: _constants.PROJECT_FIELDS_NAMES.completion_date_years,
              locale: _this.props.locale,
              component: _this.renderCompletionDateYears }))));}, _this.






























































    renderSelectCurrency = function (_ref3) {var _cx;var input = _ref3.input,meta = _ref3.meta;return (
        _react2.default.createElement(_reactSelect2.default, _extends({},
        input, {
          value: input.value || _PublishPropertyFormConstants.currencies.USD,
          options: _PublishPropertyFormConstants.currenciesOptions,
          onChange: function onChange(option) {return input.onChange(option.value);},
          searchable: false,
          clearable: false,
          instanceId: 'currency',
          placeholder: _this.props.translate('currency').toString(),
          className: (0, _classnames2.default)(styles.currencySelect, (_cx = {}, _cx[styles.not_valid] = meta.touched && meta.error && !meta.active, _cx)) })));}, _this.



    renderPrice = function () {return (
        _react2.default.createElement('div', null,
          _react2.default.createElement('div', { className: styles.priceWrapper },
            _react2.default.createElement('span', { className: styles.label },
              _this.props.translate('addNewProject', 'price'),
              _react2.default.createElement('span', { className: 'req' }, '*')),

            _react2.default.createElement(_reactScroll.Element, { name: _constants.PROJECT_FIELDS_NAMES.minimal_price, className: styles.fieldset },
              _react2.default.createElement(_components.OMPriceInput, {
                field: _constants.PROJECT_FIELDS_NAMES.minimal_price,
                locale: _this.props.locale,
                isForeign: true,
                placeholder: '' + _this.props.translate('addNewProject', 'minimalPrice'),
                isMobile: _this.props.isMobile,
                withLabel: false }),

              _this.props.translate('addNewProject', 'or'),
              _react2.default.createElement(_components.OMPriceInput, {
                field: _constants.PROJECT_FIELDS_NAMES.exact_price,
                isForeign: true,
                locale: _this.props.locale,
                placeholder: '' + _this.props.translate('addNewProject', 'exactPrice'),
                isMobile: _this.props.isMobile,
                withLabel: false })))));}, _this.






    renderShowAnotherLanguages = function () {var _this$props =
      _this.props,translate = _this$props.translate,locale = _this$props.locale,isForeign = _this$props.isForeign,fields = _this$props.fields;

      return (
        _react2.default.createElement('div', null,
          _react2.default.createElement(_reactScroll.Element, { name: _constants.PROJECT_FIELDS_NAMES.name_project, className: styles.formRow },
            _react2.default.createElement('div', { className: styles.formRowTitle },
              _react2.default.createElement('span', { className: styles.title },
                translate('addNewProject', 'projectName'),
                _react2.default.createElement('span', { className: 'req' }, '*'))),


            _react2.default.createElement(_components.OMTextFieldWithOptionsLang, {
              translate: translate,
              classNameTabs: 'project-form',
              className: 'form-control',
              name: _constants.PROJECT_FIELDS_NAMES.name_project,
              locale: locale,
              fields: fields.nameProject,
              isInput: true,
              maxLength: '80',
              placeholderInput: translate('addNewProject'),
              isOptionalLangsDisabled: !(0, _get2.default)(_this.props.fields, 'nameProject.' + (isForeign ? 'en' : 'he')),
              isForeign: isForeign })),


          _react2.default.createElement(_reactScroll.Element, { name: _constants.PROJECT_FIELDS_NAMES.summary, className: styles.formRow },
            _react2.default.createElement('div', { className: styles.formRowTitle },
              _react2.default.createElement('span', { className: styles.title },
                translate('addNewProject', 'summary'),
                _react2.default.createElement('span', { className: 'req' }, '*'))),


            _react2.default.createElement(_components.OMTextFieldWithOptionsLang, {
              translate: translate,
              name: _constants.PROJECT_FIELDS_NAMES.summary,
              locale: locale,
              fields: fields.summary,
              classNameTabs: 'project-form',
              className: styles.fieldWithOptions,
              placeholderInput: translate('addNewProject'),
              isOptionalLangsDisabled: !(0, _get2.default)(_this.props.fields, 'summary.' + (isForeign ? 'en' : 'he')),
              isForeign: isForeign,
              maxLength: '250' }))));




    }, _this.

    renderDescription = function () {var _this$props2 =
      _this.props,translate = _this$props2.translate,locale = _this$props2.locale,fields = _this$props2.fields,isForeign = _this$props2.isForeign;

      return (
        _react2.default.createElement(_reactScroll.Element, { name: _constants.PROJECT_FIELDS_NAMES.description, className: (0, _classnames2.default)(styles.formRow, styles.description) },
          _react2.default.createElement('div', { className: styles.formRowTitle },
            _this.props.translate('addNewProject', 'description'),
            _react2.default.createElement('span', { className: 'req' }, '*')),

          _react2.default.createElement(_components.OMTextFieldWithOptionsLang, {
            translate: translate,
            name: _constants.PROJECT_FIELDS_NAMES.description,
            locale: locale,
            fields: fields.description,
            maxLength: '2000',
            classNameTabs: 'project-form',
            placeholderInput: translate('addNewProject'),
            className: styles.fieldWithOptions,
            isOptionalLangsDisabled: !(0, _get2.default)(_this.props, 'fields.description.' + (isForeign ? 'en' : 'he')),
            isForeign: isForeign })));



    }, _this.

    renderStatusField = function (_ref4) {var _cx2;var input = _ref4.input,meta = _ref4.meta;
      var options = _this.formatTypeOptions();

      return (
        _react2.default.createElement(_reactSelect2.default, _extends({},
        input, {
          onChange: function onChange(option) {return input.onChange(option.value);},
          options: options,
          searchable: false,
          clearable: false,
          instanceId: 'professional_type',
          rtl: _this.props.isRtl,
          placeholder: '' + _this.props.translate('addNewProject', 'type'),
          className: (0, _classnames2.default)(styles.select, (_cx2 = {}, _cx2[styles.not_valid] = meta.touched && meta.error && !meta.active, _cx2)) })));


    }, _this.

    renderSelect = function (input, meta, placeholder, options) {var _cx3;return (
        _react2.default.createElement(_reactSelect2.default, _extends({},
        input, {
          onChange: function onChange(option) {return input.onChange(option.value);},
          options: options,
          searchable: false,
          clearable: false,
          instanceId: 'professional_type',
          rtl: _this.props.isRtl,
          placeholder: '' + _this.props.translate('addNewProject', placeholder),
          className: (0, _classnames2.default)(styles.select, (_cx3 = {}, _cx3[styles.not_valid] = meta.touched && meta.error && !meta.active, _cx3)) })));}, _this.




    renderPropertyTypes = function () {return (
        _react2.default.createElement(_reactScroll.Element, { name: _constants.PROJECT_FIELDS_NAMES.property_types, className: styles.propertyTypesWrapper },
          _react2.default.createElement('span', { className: styles.label },
            _this.props.translate('addNewProject', 'propertyTypes'),
            _react2.default.createElement('span', { className: 'req' }, '*')),

          _react2.default.createElement('div', { className: styles.propertyTypes },
            _react2.default.createElement(_reduxForm.Field, {
              name: _constants.PROJECT_FIELDS_NAMES.property_types,
              locale: _this.props.locale,
              component: _this.renderOMMultiCheckbox }))));}, _this.





    renderOMMultiCheckbox = function (_ref5) {var input = _ref5.input,meta = _ref5.meta;
      var propertyTypes = [];var _this$props3 =
      _this.props,creationNewHomes = _this$props3.creationNewHomes,translate = _this$props3.translate;

      creationNewHomes.propertyTypes.map(function (item) {return (
          propertyTypes.push({ id: item.name, label: translate('propertyTypes', item.name) }));});

      return (
        _react2.default.createElement(_components.OMMultiCheckbox, _extends({},
        input, {
          className: styles.checkboxes,
          options: propertyTypes,
          notValid: meta.touched && meta.error && !meta.active })));


    }, _this.

    renderRooms = function () {return (
        _react2.default.createElement(_reactScroll.Element, { name: _constants.PROJECT_FIELDS_NAMES.room_range, className: styles.roomsWrapper },
          _react2.default.createElement('span', { className: styles.label },
            _this.props.translate('addNewProject', 'rooms'),
            _react2.default.createElement('span', { className: 'req' }, '*')),

          _react2.default.createElement(_reduxForm.Field, {
            name: _constants.PROJECT_FIELDS_NAMES.room_range,
            locale: _this.props.locale,
            component: _this.renderCheckbox })));}, _this.




    renderCheckbox = function (_ref6) {var input = _ref6.input,meta = _ref6.meta;return (
        _react2.default.createElement(_components.OMMultiCheckbox, _extends({},
        input, {
          className: styles.rooms,
          customCheckBox: styles.customCheckBox,
          options: _constants.AMOUNT_ROOMS,
          notValid: meta.touched && meta.error && !meta.active })));}, _this.


    renderCurrency = function () {return (
        _react2.default.createElement('div', { className: styles.currencyWrapper },
          _react2.default.createElement('span', { className: styles.label },
            _this.props.translate('addNewProject', 'currency'),
            _react2.default.createElement('span', { className: 'req' }, '*')),

          _react2.default.createElement('div', { className: styles.selectWrapper },
            _react2.default.createElement(_reduxForm.Field, {
              name: _constants.PROJECT_FIELDS_NAMES.currency,
              locale: _this.props.locale,
              component: _this.renderSelectCurrency }))));}, _temp), _possibleConstructorReturn(_this, _ret);}PropertyDetails.prototype.renderAddress = function renderAddress() {var _props = this.props,translate = _props.translate,isMobile = _props.isMobile,fields = _props.fields,locale = _props.locale,anyTouched = _props.anyTouched,isRtl = _props.isRtl,reportIssue = _props.reportIssue,isAgent = _props.isAgent,token = _props.token,initialValues = _props.initialValues,receiveGeocodedPlace = _props.receiveGeocodedPlace,geocodedPlace = _props.geocodedPlace,geocodeFailed = _props.geocodeFailed,changeValue = _props.changeValue,isForeign = _props.isForeign;var parameters = { isMobile: isMobile, fields: fields, locale: locale, anyTouched: anyTouched, isRtl: isRtl, reportIssue: reportIssue };return _react2.default.createElement('div', { className: styles.addressWrapper }, _react2.default.createElement('span', { className: styles.label }, translate('addNewProject', 'address'), _react2.default.createElement('span', { className: 'req' }, '*')), _react2.default.createElement(_reactScroll.Element, { name: _constants.PROJECT_FIELDS_NAMES.address, className: styles.fieldset }, _react2.default.createElement(_components.PublishAddressBlock, _extends({}, parameters, { translate: translate('publishProperty'), name: _constants.PROJECT_FIELDS_NAMES.address, value: fields.address, changeValue: changeValue, initialValue: initialValues && (initialValues.address || {}), isRealtor: isAgent, receiveGeocodedPlace: receiveGeocodedPlace, geocodedPlace: geocodedPlace, geocodeFailed: geocodeFailed, isMobile: isMobile, token: token, className: styles.addressBlock, isForeign: isForeign, rootTranslate: this.props.translate }))));};PropertyDetails.prototype.




  render = function render() {var _props2 =













    this.props,creationNewHomes = _props2.creationNewHomes,state = _props2.state,fields = _props2.fields,translate = _props2.translate,isMobile = _props2.isMobile,token = _props2.token,addAssetToDelete = _props2.addAssetToDelete,projectImag = _props2.projectImag,initialValues = _props2.initialValues,changeValue = _props2.changeValue,openMessageModal = _props2.openMessageModal,isForeign = _props2.isForeign;

    var isShowAnotherLanguages = !!(0, _get2.default)(fields, 'nameProject.' + (isForeign ? 'en' : 'he')) &&
    !!(0, _get2.default)(fields, 'summary.' + (isForeign ? 'en' : 'he')) &&
    !!(0, _get2.default)(fields, 'description.' + (isForeign ? 'en' : 'he'));

    return (
      _react2.default.createElement('div', { className: styles.sectionBlock },
        this.renderShowAnotherLanguages(),
        this.renderDescription(),
        isShowAnotherLanguages &&
        _react2.default.createElement('div', { className: styles.title },
          _react2.default.createElement('p', null, this.props.translate('addNewProject', 'propertyDetailsTitle'))),


        isShowAnotherLanguages && this.renderAddress(),
        state.inputData && isShowAnotherLanguages && this.renderPrice(),
        state.inputData && isShowAnotherLanguages && this.props.isForeign && this.renderCurrency(),
        state.inputData && isShowAnotherLanguages && this.renderStatus(),
        state.inputData && isShowAnotherLanguages && this.renderCompletionDate(),
        state.inputData &&
        isShowAnotherLanguages &&
        creationNewHomes.propertyTypes.length !==
        0 && this.renderPropertyTypes(),

        state.inputData && isShowAnotherLanguages && this.renderRooms(),
        state.inputData && isShowAnotherLanguages &&
        _react2.default.createElement(_ProjectImages2.default, {
          translate: translate,
          isMobile: isMobile,
          token: token,
          fields: fields,
          addAssetToDelete: addAssetToDelete,
          projectImag: projectImag,
          initialValues: initialValues,
          updateContent: changeValue,
          openMessageModal: openMessageModal })));




  };return PropertyDetails;}(_react.Component);exports.default = PropertyDetails;


PropertyDetails.propTypes = {
  translate: _propTypes2.default.func.isRequired,
  locale: _propTypes2.default.string.isRequired,
  isMobile: _propTypes2.default.bool,
  token: _propTypes2.default.string,
  addAssetToDelete: _propTypes2.default.func,
  changeValue: _propTypes2.default.func,
  isRtl: _propTypes2.default.bool,
  isEditProject: _propTypes2.default.bool,
  creationNewHomes: _propTypes2.default.object,
  fields: _propTypes2.default.object,
  state: _propTypes2.default.object,
  initialValues: _propTypes2.default.object,
  projectImag: _propTypes2.default.array,
  anyTouched: _propTypes2.default.bool,
  geocodedPlace: _propTypes2.default.object,
  geocodeFailed: _propTypes2.default.bool,
  receiveGeocodedPlace: _propTypes2.default.func,
  reportIssue: _propTypes2.default.func,
  getRenderMap: _propTypes2.default.func,
  openMessageModal: _propTypes2.default.func,
  isAgent: _propTypes2.default.bool,
  isForeign: _propTypes2.default.bool };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PublishNewHomesForm/PropertyDetails.js
// module id = 3043
// module chunks = 0